import Vue from 'vue';
import Router from 'vue-router';
import { userService } from './services/userService';
import Login from './views/Login.vue';
import Dashboard from './views/Dashboard.vue';
import UserMgmt from './views/UserMgmt.vue';
import EmpDialog from './components/EmpDialog';
import PlanillaDetails from './components/PlanillaDetails';
import AttendReportTable from './components/Tables/AttendReportTable';
import EmpTable from './components/Tables/EmpTable';
import PlanillaTable from './components/Tables/PlanillaTable';
import PageNotFound from './views/PageNotFound.vue';
import ReportDialog from './components/ReportDialog';
import AttendScanView from './views/AttendScanView.vue';
import AttendView from './views/AttendView.vue';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
      },
    },
    { name: 'attend', path: '/attend', component: AttendView },
    {
      name: 'attendScan',
      path: '/attend_scan',
      component: AttendScanView,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { reqSupervisor: true },
      children: [
        {
          name: 'attendReport',
          path: 'planilla/attend',
          component: AttendReportTable,
          children: [
            { name: 'attendDetail', path: ':id', component: ReportDialog },
          ],
        },
        {
          name: 'payroll',
          path: 'planilla/payroll',
          component: PlanillaTable,
          children: [
            { name: 'payrollDetail', path: ':id', component: PlanillaDetails },
          ],
        },
        {
          name: 'employee',
          path: 'employee',
          component: EmpTable,
          children: [
            {
              name: 'edit',
              meta: { reqEditor: true },
              path: 'edit/:id?',
              component: EmpDialog,
            },
            { name: 'detail', path: ':id', component: EmpDialog },
            {
              name: 'enroll',
              meta: { reqEditor: true },
              path: 'enroll/:id',
              component: EmpDialog,
            },
          ],
        },
      ],
    },
    {
      path: '/admin',
      name: 'UserMgmt',
      component: UserMgmt,
      meta: {
        reqAdmin: true,
      },
    },
    { path: '*', component: PageNotFound, redirect: '/' },
  ],
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  const reqEditor = to.matched.some((record) => record.meta.reqEditor);
  const reqAdmin = to.matched.some((record) => record.meta.reqAdmin);
  const reqSupervisor = to.matched.some((record) => record.meta.reqSupervisor);
  const onlyWhenLoggedOut = to.matched.some(
    (record) => record.meta.onlyWhenLoggedOut,
  );
  const loggedIn = userService.getUser();
  if (!isPublic && !loggedIn) {
    return next({
      path: '/',
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    });
  }
  if (reqSupervisor && !loggedIn.isEditor && !loggedIn.isSupervisor) {
    return next({ path: '/attend' });
  }
  if (reqEditor && !loggedIn.isEditor) {
    return next({
      path: loggedIn.isSupervisor ? '/attend' : '/attend_scan',
    });
  }
  if (reqAdmin && !loggedIn.isAdmin) {
    return next({
      path: loggedIn.isEditor ? '/dashboard/employee' : '/attend',
    });
  }
  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next(loggedIn.isEditor ? '/dashboard/employee' : '/attend');
  }
  next();
});

function hasQueryParams(route) {
  if (typeof route === 'string') return route.includes('?');
  return Object.keys(route.query).length;
}
function isSameQuery(to, from) {
  if (to === '/') return false;
  if (typeof to === 'string') return true;
  return Object.keys(to.query)[0] === Object.keys(from.query)[0];
}

router.push = function push(location, onComplete, onAbort) {
  var this$1 = this;
  const from = this.history.current;
  if (
    isSameQuery(location, from) &&
    hasQueryParams(from) &&
    !hasQueryParams(location)
  ) {
    const query = from.query;
    if (typeof location === 'string') location = { path: location, query };
    else location = { ...location, query };
  }
  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    });
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};
export default router;
